import {
  DASHBOARD_LOGIN,
  EMAIL,
  PHONE,
  PHONE_NO_SPACES,
  TIME_HOLIDAY_HOURS,
  TIME_WORKING_END_HOURS,
} from '../constants';

const cz = {
  error: {
    generic: 'Něco se pokazilo...',
    unauthorized: 'Přihlášení se nezdařilo',
    validation: {
      already_exists_in_db: `Pro zadané údaje už existuje zákaznický účet. Prosím, přihlaste se <a href="${DASHBOARD_LOGIN}">ZDE</a> nebo nás kontaktujte na zákaznické lince <span class=bold>${PHONE}</span>`,
      code_doesnt_match_pattern: 'Formát rodného čísla neodpovídá vzoru',
      document_file_size: 'Velikost souboru nesmí překročit 10 MB',
      document_file_type: 'Jsou podporovány formáty JPG, PNG, a PDF',
      empty: 'Údaj je povinný',
      empty_consent:
        'Je nám líto, ale bez odsouhlasení výše uvedeného textu nelze provést žádost o půjčku',
      less_than_one: 'Číslo musí být větší než 1',
      not_a_number: 'Lze zadat pouze číslice',
      negative_number: 'Pole nemůže obsahovat zápornou hodnotu',
      integer_number: 'Používejte pouze čísla',
      not_safe_text: 'Smí obsahovat pouze písmena, mezeru a znaky &-+/,.',
      too_short: 'Musí obsahovat nejméně 2 znaky',
      minLength: 'Musí obsahovat nejméně {length} znaků',
      requires_number: 'Musí obsahovat nejméně 1 číslici',
      restrict_diacritics_chars: 'Písmena s diakritikou nejsou povolené',
      passwords_not_equal: 'Hesla se neshodují',
      incorrect_password: 'Neplatné heslo',
      new_password_not_new: 'Nové heslo se musí lišit od stávajícího hesla',
      has_uppercase: 'Musí obsahovat nejméně 1 velké písmeno',
      has_lowercase: 'Musí obsahovat nejméně 1 malé písmeno',
      not_safe_name: 'Smí obsahovat pouze písmena, mezeru a znaky',
      not_phone_number: 'Použijte číslo mobilního telefonu',
      not_email: 'Zadaná emailová adresa není platná',
      personal_id_invalid: 'Prosím, zadejte své rodné číslo s lomítkem',
      personal_id_empty: 'Rodné číslo je vyžadováno',
      personal_id_doesnt_match_pattern: 'Formát rodného čísla neodpovídá vzoru',
      personal_id_wrong_length:
        'Rodné číslo musí mít délku 9 nebo 10 číslic včetně lomítka',
      personal_id_wrong_checksum: 'Kontrolní součet rodného čísla je neplatný',
      personal_id_month_invalid:
        'Zadané rodné číslo obsahuje neplatný měsíc (>12)',
      personal_id_date_invalid: 'Zadané rodné číslo obsahuje neplatné datum',
      bank_account: 'Číslo bankovního účtu není platné',
      id_card_invalid: 'Číslo občanského průkazu smí obsahovat pouze číslice',
      postal_code_invalid:
        'Poštovní směrovací číslo musí být ve formátu 150 00',
      house_number_invalid:
        'Smí obsahovat pouze písmena, mezeru a znaky &-+/,.',
      invalid_image:
        'Fotografii nelze použít. Prosíme nahrajte znovu, nebo zvolte jiný způsob nahrání',
      failed_to_complete_the_operation: `Pro zadané údaje už existuje zákaznický účet. Prosím, přihlaste se <a href="https://account.kimbi.cz/login">ZDE</a> nebo nás kontaktujte na zákaznické lince <span class=bold>${PHONE}</span>`,
      incorrect_code: 'Ověřovací kód je neplatný',
      invalid_phone_number: 'Telefonní číslo je neplatné',
      invalid_credentials: 'Neplatný email nebo heslo',
      too_young: 'Žádat o půjčku je možné od 18 let',
      too_old:
        'Věkový limit překročen. Maximální možný věk pro podání žádosti je 78 let.',
      wrong_digital_code: 'Zadejte prosím platný ověřovací kód',
      '{javax.validation.constraints.Pattern.message}': 'Nesprávný formát',
      wrong_postal_code_format:
        'Poštovní směrovací číslo musí být ve formátu 150 00',
      invalid_format: 'Nesprávný formát',
      out_of_range: 'Nevešli jste se do limitu',
      household_members_maxamount: 'Maximální počet členů domácnosti je 20.',
      household_employedmembers_toobig:
        'Počet členů domácnosti s příjmem musí být roven nebo menší, než celkový počet členů domácnosti.',
      has_alphanumeric_chars_with_subject:
        '{subject} musí obsahovat písmena i číslice',
      has_alphanumeric_chars: 'Musí obsahovat písmena i číslice',
      password_contains_space: 'Znak mezery není povolen',
      max_length_with_subject: '{subject} nesmí přesáhnout {length} znaků',
      max_length: 'Nesmí přesáhnout {length} znaků',
      restrict_special_chars: 'Speciální znaky jako (!@#$...) nejsou povoleny',
      service_unavailable:
        'Vyskytl se problém.\n Omlouváme se za nepříjemnosti, měli jsme technický problém. Zkuste to prosím znovu později nebo nás kontaktujte na telefonním čísle <strong><a href="tel:225852311">225 852 311</a>.</strong>',
      expenses_too_low: 'Měsíční výdaje jsou příliš nízké',
      household_members_toosmall:
        'Číslo musí být větší nebo rovno počtu členů domácnosti s příjmem',
      income_smaller_than_expenses:
        'Příjmy nemohou být nižší než měsíční výdaje.',
    },
    bank_id: {
      general: 'Něco se pokazilo...',
    },
  },

  time: {
    seconds: {
      one: 'sekunda',
      few: 'sekundy',
      many: 'sekund',
    },
    days: {
      one: 'den',
      few: 'dny',
      many: 'dnů',
    },
    months: {
      one: 'měsíc',
      few: 'měsíce',
      many: 'měsíců',
    },
  },

  common: {
    continue: 'Pokračovat',
    confirm: 'Potvrdit',
    print: 'Stáhnout',
    back: 'Zpět na předchozí stránku',
    currency: 'Kč',
    skip: 'Zaslat později',
    loan_overview: 'Přehled půjčky',
    loan: 'Výše půjčky',
    mtp: 'Minimální měsíční platba',
    days: 'dnů',
    interest: 'Úrok',
    apr: 'Roční úroková sazba',
    logout: 'Odhlásit',
    footer_text:
      'Zaplo Finance s.r.o., Jungmannova 745, 110 00 Praha 1 – Nové Město je vedeno u Městského soudu v Praze pod spisovou značkou C 205150.',
    edit: 'Upravit',
    edit_amount: 'Upravit částku',
    retry: 'Zkusit znovu',
    show_more: 'Zobrazit více',
    show_less: 'Zobrazit méně',
    or: 'nebo',
  },

  progress: {
    intro: 'Žádost o půjčku',
    personalData: 'Osobní údaje',
    verification: 'Ověření',
    summary: 'Shrnutí půjčky',
  },

  not_found: {
    html_title: 'Omlouváme se, požadovaná stránka neexistuje - kimbi.cz',
    title: 'Omlouváme se, požadovaná stránka neexistuje',
    description:
      'Je možné, že byla odstraněna, přejmenována nebo není dočasně dostupná.',
    button: 'Začít novou registraci',
    link: 'Zpět na hlavní stránku',
  },

  login: {
    html_title: 'Přihlášení do zákaznického účtu - kimbi.cz',
    title: 'Přihlášení do zákaznického účtu',
    email: 'Email',
    password: 'Heslo',
    submit: 'Přihlásit se',
    forgot_password: 'Nepamatujete si heslo?',
  },

  adjust_income: {
    income_discrepancy_title: 'Rozdíl v uvedeném příjmu',
    declared_income: 'Vámi uvedený příjem',
    verified_bank_income: 'Ověřený příjem z účtu',
    please_select_how_to_proceed:
      'Prosím, vyberte, jak chcete dále pokračovat:',
    continue_with_verified_income: 'Pokračovat s ověřeným příjmem',
    continue: 'Pokračovat',
    submit_other_proof_of_income: 'Předložit jiný doklad o příjmu',
    upload_attachments: 'Nahrát přílohy',
    income_verification_message:
      'Vážený kliente,\n na základě ověření příchozích plateb na Vašem bankovním účtu jsme zjistili nižší příjem, než uvádíte.',
  },

  welcome_back: {
    html_title: 'Vítejte zpět - kimbi.cz',
    title: 'Vítejte zpět',
    button: 'Požádat o půjčku',
    refresh_button_text: 'AKTUALIZOVAT STAV ŽÁDOSTI',
    check_again_in: 'Znovu zkontrolovat za',
    overall_status_message:
      'Pokud čekáme na vaše podklady, platbu nebo probíhá manuální kontrola, zkuste kliknout na tlačítko pro aktualizaci stavu. V případě manuální kontroly může vyřízení trvat déle podle pracovní doby Zákaznického centra.',
    consent_heading:
      'Pro možnost čerpání našich služeb v plném rozsahu Vás žádáme i o udělení tohoto souhlasu:',
    identity_requested: {
      title: 'K dokončení Vaší žádosti je potřeba',
      description:
        'Ověřit Vaší totožnost prostřednictvím <strong>Bankovní identity</strong> nebo nahráním <strong>fotografie Vašeho občanského průkazu.</strong>',
    },
    identity_ocr_in_progress: {
      title: 'Nyní zpracováváme Vámi poskytnuté osobní údaje',
      description:
        'O výsledku Vás budeme informovat neprodleně po vyhodnocení žádosti.',
    },
    identity_manual_check_needed: {
      title: 'Nyní zpracováváme Vámi poskytnuté osobní údaje',
      description:
        'O výsledku Vás budeme informovat neprodleně po vyhodnocení žádosti.',
    },
    identity_ocr_wrong_document: {
      title: 'Ověření totožnosti neproběhlo v pořádku',
      description:
        'Nebyli jsme schopni zpracovat Vámi poskytnutou fotografii občanského průkazu. Prosíme, ověřte vaší totožnost prostřednictvím <strong>Bankovní identity nebo nahráním nové fotografie Vašeho občanského průkazu.</strong>',
    },
    identity_bank_id_in_progress: {
      title: 'Dokončete ověření totožnosti',
      description: 's Bankovní identitou nebo vyberte jinou možnost.',
    },
    identity_bank_id_in_progress_no_cz: {
      title:
        'Dokončete ověření Vaší totožnost prostřednictvím Bankovní identity - POZOR, možnost ověření Vaší identify jiným způsobem nebude akceptována.',

      description: 's Bankovní identitou nebo vyberte jinou možnost.',
    },
    identity_bank_id_error: {
      title: 'K dokončení Vaší žádosti je potřeba:',
      description:
        'Ověřte Vaší totožnost prostřednictvím Bankovní identity nebo nám nahrajte fotografie Vašeho občanského průkazu.',
    },
    identity_bank_id_error_no_cz: {
      title: 'K dokončení Vaší žádosti je potřeba:',
      description:
        'Ověřte Vaší totožnost prostřednictvím Bankovní identity - POZOR, možnost ověření Vaší identify jiným způsobem nebude akceptována.',
    },
    identity_bank_id_data_mismatch: {
      title: 'Nebyli jsme schopni zpracovat Vámi poskytnuté osobní údaje',
      description:
        'Prosíme, ověřte svou totožnost nahráním fotografie Vašeho občanského průkazu.',
    },
    identity_bank_id_data_mismatch_no_cz: {
      title:
        '	Je nám líto, půjčka Vám nemůže být poskytnuta z interních důvodů.',
      description:
        'Prosíme, ověřte svou totožnost nahráním fotografie Vašeho občanského průkazu.',
    },
    identity_bank_id_rejected: {
      title: 'Přístup k Vašim datům ve Vaší bance nám byl odepřen',
      description: 'Prosíme, zvolte jiný způsob ověření totožnosti.',
    },
    identity_bank_id_rejected_by_client: {
      title: 'Osobní údaje poskytnuté Vaší bankou byly odmítnuty.',
      description:
        'Nebyl nám udělen souhlas s použitím Vašich údajů. Prosíme, ověřte svou totožnost nahráním fotografie občanského průkazu.',
    },
    identity_bank_id_rejected_by_client_no_cz: {
      title: 'Osobní údaje poskytnuté Vaší bankou byly odmítnuty.',
      description:
        'Nebyl nám z Vaší strany udělen souhlas s použitím Vašich údajů. POZOR, možnost ověření Vaší identify jiným způsobem nebude akceptována.',
    },
    identity_approved: {
      title: 'Děkujeme, ověření Vaší totožnosti proběhlo v pořádku',
    },
    bank_account_requested: {
      title: 'K dokončení Vaší žádosti je potřeba',
      description:
        '<ul><li>Ověřit Váš bankovní účet</li><li>Ověřit Vaše příjmy</li></ul>',
    },
    bank_account_psd2_payment_error: {
      title: 'Omlouváme se, ale',
      description:
        'ověřovací platbu se nepodařilo na straně banky zpracovat. Prosím, zadejte platbu ručně ve Vašem internetovém bankovnictví.',
    },
    bank_account_psd2_name_surname_mismatch: {
      title: 'Omlouváme se, ale',
      description:
        'Bankovní účet není veden na Vaše jméno. Prosíme, použijte účet, který je veden na Vaše jméno.',
    },
    bank_account_psd2_payment_initiated: {
      title: 'Nyní zpracováváme výsledek zadání platby na straně banky',
      description:
        'V závislosti na Vaší bance, odeslání peněz na náš bankovní účet může trvat až <strong>20 minut</strong>.',
    },
    bank_account_psd2_payment_sent: {
      title: 'Peníze odešly z vaší banky, nyní čekáme až dorazí k nám na účet',
      description: 'Rychlost připsání platby na náš účet závisí na Vaší bance.',
    },
    bank_account_psd2_payment_sent_income: {
      title: 'Peníze odešly z vaší banky, nyní čekáme až dorazí k nám na účet',
      description:
        'Rychlost připsání platby na náš účet závisí na Vaší bance.<br /><br />Pokud čekáme na vaše podklady, platbu nebo probíhá manuální kontrola, zkuste kliknout na tlačítko pro aktualizaci stavu. V případě manuální kontroly může vyřízení trvat déle podle pracovní doby Zákaznického centra.',
    },
    bank_account_bank_id_in_progress: {
      title: 'Dokončete proces',
      description:
        'Dokončete krok potvrzení bankovního účtu poskytnutého Bankovní identitou nebo vyberte jinou možnost ověření bankovního účtu.',
    },
    bank_account_approved: {
      title: 'Děkujeme, ověření bankovního účtu proběhlo v pořádku',
      description: 'Dokončete krok ověření Vašeho příjmu',
    },
    bank_account_approved_with_income: {
      title: 'Děkujeme, ověření bankovního účtu a příjmu proběhlo v pořádku',
      description:
        '<br />Pokud čekáme na vaše podklady, platbu nebo probíhá manuální kontrola, zkuste kliknout na tlačítko pro aktualizaci stavu. V případě manuální kontroly může vyřízení trvat déle podle pracovní doby Zákaznického centra',
    },
  },
  intro: {
    html_title: 'Žádost o půjčku - kimbi.cz',
    title: 'Žádost o půjčku',
    customer_title: 'Jste již zákazníkem?',
    customer_message: 'Jděte do svého zákaznického účtu',
    login: 'přihlášení zde',
    info: 'Vše, co potřebujete k žádosti',
    id: 'Občanský průkaz',
    mobile: 'Mobilní telefon',
    email: 'Email',
    info_optional: 'Pro urychlení vyhodnocení žádosti',
    bank_id: 'Vyplnění žádosti o půjčku s Bankovní identitou',
    online_banking_access: 'Přístup do internetového bankovnictví',
    more_information: 'Více informací',
    how_it_works: 'Jak to funguje',
    video_banner_title: 'Chcete se podívat, jak to funguje?',
    video_banner_description:
      'Podívejte se na toto krátké video a prohlédněte si všechny kroky tohoto procesu.',
    video_banner_link: 'Podívejte se na video',
    modal_bankId: {
      heading: 'Nejrychlejší a nejpohodlnější způsob jak požádat o půjčku',
      point_1: 'Přesměrujeme Vás na stránku bankovní identity',
      point_2:
        'Na stránce bankovní identity zvolíte svou banku jako způsob přihlášení se',
      point_3: 'Po přihlášení nám udělíte souhlas se zpracováním Vašich údajů',
      point_4:
        'Poté Vás bezpečně odhlásíme a můžete dále pokračovat v žádosti.',
    },
    modal_internet_banking: {
      heading: 'Ověření přes internetové bankovnictví',
      supported_banks: 'Podporované banky',
      point_1: 'Požádáme Vás o souhlas k propojení s Vaším bankovním účtem',
      point_2:
        'Abychom mohli Vaši žádost zpracovat co nejrychleji, připravíme stažení výpisů z ůčtu a ověřovací platbu za Vás',
      point_3:
        'Veškeré uvedené činnosti budou předpřipraveny. Vy je pouze zkontrojulete a odsouhlasíte',
      point_4: 'Po dokončení žádosti Vás bezpečně odhlásíme',
    },
  },
  employer_info: {
    identification_number: 'IČ: ',
    search: 'Vyhledávání',
  },
  personal_details: {
    already_exists: {
      text: `Pro zadané údaje už existuje zákaznický účet. Prosím, přihlaste se, nebo nás kontaktujte na zákaznické lince <span class=bold>${PHONE}</span>`,
      button: 'Přihlásit se',
    },
    html_title: 'Vyplňte, prosím, své osobní údaje - kimbi.cz',
    title: 'Vyplňte, prosím, své osobní údaje',
    info: 'Vyplňte všechna pole ve formuláři. Při vyplňování používejte diakritiku (háčky a čárky), aby při ověřování Vašich údajů nedocházelo k chybám.',
    first_name: 'Jméno',
    last_name: 'Příjmení',
    mobile_phone: 'Mobilní telefon',
    personal_id: 'Rodné číslo',
    monthly_income: 'Čistý měsíční příjem',
    monthly_income_hint:
      'Uveďte výši Vašeho čistého měsíčního příjmu. Čistý měšíční příjem (po zdanění)',
    monthly_expenses: 'Měsíční výdaje',
    monthly_expenses_hint: 'Uveďte Vaše čisté měsíční výdaje',

    permanent_address_title: 'Adresa trvalého bydliště',
    city: 'Město / obec',
    street: 'Ulice',
    house_flat_number: 'Číslo popisné',
    postal_code: 'PSČ',

    account_setup_title: 'Zákaznický účet',
    email: 'Emailová adresa',
    email_title: 'Údaje k přihlášení do Kimbi účtu',
    email_hint:
      'Údaje slouží k přihlášení a spravování Vašeho zákaznického učtu online.',
    password: 'Heslo',
    password_hint:
      'Heslo musí mít délku nejméně 7 znaků a musí obsahovat minimálně 1 číslici. Pozor, heslo rozlišuje velká a malá písmena.',
    terms_and_conditions_title: 'Smluvní podmínky',
    terms_and_conditions_info_1:
      'Vaše osobní údaje zpracováváme, protože je to nezbytné pro splnění smlouvy, jejíž smluvní stranou jste nebo pro provedení opatření přijatých před uzavřením smlouvy na Vaši žádost, případně je to nezbytné pro splnění právní povinnosti, která se na nás vztahuje (například povinnost identifikace pro účely boje proti legalizaci výnosů z trestné činnosti, povinnost archivace apod.).',
    terms_and_conditions_info_2:
      'Podrobnosti, k tomu jak zpracováváme Vaše osobní údaje a jaká v této souvislosti máte práva, najdete na našich stránkách o ochraně osobních údajů.',
    consents_title:
      'Pro možnost čerpání našich služeb v plném rozsahu Vás žádáme i o udělení těchto souhlasů:',
  },

  offline_psd: {
    result: {
      DONE: {
        title: 'Děkujeme, Vaše žádost se zpracovává',
        subtitle: 'O jejím výsledku Vás budeme neprodleně informovat.',
      },
      ERROR: {
        title: 'Omlouváme se, něco se pokazilo',
        subtitle: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
      },
      PAYMENT_FAILED: {
        title: 'Omlouváme se, provedení ověřovací platby se nezdařilo',
        subtitle: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
      },
    },
  },

  phone_verification: {
    html_title: 'Ověření telefonního čísla - kimbi.cz',
    verification: 'Ověření telefonního čísla',
    code_sent:
      'Pro ověření telefonního čísla zadejte kód, který Vám byl zaslán na Vámi poskytnuté telefonní číslo',
    wrong_number: '(špatné číslo?)',
    enter_code: 'Zadejte Váš ověřovací kód',
    get_new_code: 'Znovu zaslat kód',
    get_phone_call: 'Získat kód telefonicky',
    contact_us: `Může chvíli trvat, než vám SMS dorazí. Pokud vám SMS s kódem nedorazila, klikněte na „Získat kód telefonicky“ a ihned vám zavolá automat a kód vám nadiktuje.
                  Pokud se vám ani tak nepodařilo kód získat, kontaktujte naší zákaznickou linku v pracovní době na čísle <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a>.`,
    change_number: 'Změna telefonního čísla',
    insert_number:
      'Zadáte své telefonní číslo a my vám na něj pošleme SMS s jednorázovým heslem',
    mobile: 'Mobilní telefon',
  },

  upsale: {
    html_title: 'Připravili jsme pro Vás nabídku',
    button: 'Zvolit jinou částku',
    button_change_amount: 'Souhlasím, pokračovat',
    card_title: 'Připravili jsme pro Vás nabídku',
    card_text1:
      'Na základě ověření Vaší úvěruschopnosti jsme pro Vás připravili nabídku.',
    card_text2:
      'Pokud se Vám nabídka líbí, můžete ji přijmout stisknutím tlačítka ',
    card_text3: 'Souhlasím, Pokračovat, ',
    card_text4:
      'pokud chcete zvolit jinou částku klikněte na tlačítko Zvolit jinou částku.',
    title: 'Přepočítejte si svou půjčku v nové výši',
    table: {
      loan: 'Půjčka',
      futureExtensionFees: 'Následující minimální měsíční splátka:',
      due_date: 'Datum splatnosti minimální měsíční splátky',
      mtp: 'První minimální měsíční splátka',
      interest: 'Zápůjční úroková sazba (ročně)',
    },
    loan_example:
      '<b>Ilustrativní příklad Kimbi půjčky:</b> Toto je ukázkový příklad půjčky na 10 000 Kč na 12 měsíců, s roční úrokovou sazbou 30 %, RPSN 65,76 %. Výše minimální měsíční splátky 1083 Kč. Celková částka splatná spotřebitelem za období 12 měsíců, je 12 996 Kč. <br><br> Celkové náklady spotřebitelského úvěru jsou 2 996 Kč. Při uzavření smlouvy on-line je klientem zasílána 0,01 Kč pro identifikaci. Úroková sazba je stanovena u jednotlivých úvěrů na základě individuálního vyhodnocení příslušné žádosti. Zaplo Finance s.r.o. si vyhrazuje právo na posouzení úvěrové žádosti. Na poskytnutí úvěru nevzniká právní nárok.',
  },

  downsale: {
    html_title: 'Naše nabídka - kimbi.cz',
    button: 'Chci půjčku',
    card_title: 'Přehled půjčky',
    info_text:
      'Na základě Vaší úvěruschopnosti Vám nemůžeme poskytnout půjčku v požadované výši, ale můžeme Vám nabídnout sníženou částku. <br><br>Pokud Vám bude nová nabídka vyhovovat, potvrďte ji a poté pokračujte na pročtení a souhlas s předsmluvními informacemi a smlouvě o úvěru.',
    info_title: 'Proč byla částka snížena?',
    prev_amount: 'Žádali jste o',
    sub_title:
      'Omlouváme se, ale v tuto chvíli Vám nemůžeme poskytnout půjčku ve Vámi požadované výši. Máme pro Vás ale novou nabídku.',
    title: 'Naše nabídka',
    proposal_amount: 'Můžeme Vám nabídnout',
  },

  consent: {
    html_title: 'Potvrzení žádosti a smluvní dokumentace - kimbi.cz',
    contract_documentation: 'Potvrzení žádosti a smluvní dokumentace',
    read: 'Četl(a) jsem tyto <span>předsmluvní informace</span>, byly mi vysvětleny a rozumím jim.',
    comfirm:
      'Potvrzuji tímto, že jsem přečetl(a) a jsem srozuměn(a) s obsahem <span>smlouvy o úvěru</span> a souvisejícími obchodními podmínkami a chci ji uzavřít.',
    modal_agreement:
      'Formulář pro standardní informace o spotřebitelském úvěru',
    modal_legal: 'Smlouva o úvěru',
    banner: 'Pro potvrzení prosím posuňte dolů a přečtěte si.',
  },

  digital_signature: {
    modal_digital_signature: 'Podepsání smlouvy',
    digital_info_pre_phone:
      'Pro podepsání této smlouvy o úvěru zadejte kód, který Vám byl zaslán na Vaši emailovou adresu <b>{{clientEmail}}</b> a telefonní číslo <b>{{clientPhone}}</b>',
    digital_info_phone: 'a telefonní číslo',
    title: 'Podepsání smlouvy',
    enter_code: 'Zadejte Váš ověřovací kód',
    get_new_code: 'Znovu zaslat kód',
    contact_us: `Může chvíli trvat, než Vám SMS dorazí. Pokud jste SMS neobdrželi, tak pro dokončení žádosti kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
    btn: 'Podepsat a potvrdit',
  },

  identification: {
    html_title: 'Ověření totožnosti - kimbi.cz',
    title: 'Ověření totožnosti',
    info: 'Připravte si, prosím, Váš občanský průkaz. Fotografii nahrajte prostřednictvím Vašeho mobilního zařízení.',
    phone_id_title:
      'Pořidte fotografii Vašeho občanského průkazu pomocí mobilního telefonu',
    phone_id_info:
      'Po otevření odkazu, který Vám zašleme SMS zprávou, vyfoťte pomocí mobilního telefonu obě dvě strany Vašeho občanského průkazu.',
    mobile_ocr_id_info:
      'Po otevření odkazu vyfoťte pomocí mobilního telefonu obě dvě strany Vašeho občanského průkazu.',
    mobile_ocr_button: 'Vyfotit doklad',
    sms_button: 'Odeslat SMS',
    phone_id_footer: `Může chvíli trvat, než Vám SMS dorazí. Pokud jste SMS neobdrželi, tak pro dokončení žádosti kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
  },

  identification_conecting: {
    title: 'Pokračujte na mobilním telefonu',
    hint: '(Nezavírejte tuto stránku)',
    time: 'Platnost SMS zprávy vyprší za',
  },

  identification_expired: {
    title: 'Potřebujete více času?',
    confirm: 'Ano',
    close: 'Ne, děkuji. Zkusím to jinak nebo později.',
  },

  identification_processing: {
    title: 'Kontrola Vašich údajů',
    hint: 'Toto okno nezavírejte, nahrání může trvat několik minut.',
  },

  identification_failed: {
    title: 'Nahrávání dokumentu nebylo úspěšné',
    retry: 'Začít znovu',
  },

  identification_manual: {
    html_title: 'Ověření bankovního účtu - kimbi.cz',
    title: 'Ověření bankovního účtu',
    message:
      'Pro dokončení žádost je nutné provést za účelem identifikace ověřovací platbu ve výši 0,01 Kč (tj. jeden haléř). Platbu proveďte pod variabilním symbolem na níže uvedený účet.',
    choose_bank: 'Účet pro zaslání platby:',
    important:
      'Důležité! Při převodu 0,01 Kč uveďte {identificationNumber} jako variabilní symbol.',
    info_message: 'Smlouva o úvěru a Obchodní podmínky',
    terms_and_conditions: 'Obchodní podmínky',
    loan_agreement: 'Smlouva o úvěru',
    confirm: 'Dokončit žádost',
    payee: 'Příjemce platby',
    bank_name: 'Název banky',
    account_number: 'Číslo účtu',
    variable_symbol: 'Variabilní symbol',
    copy: 'Kopírovat',
    copied: 'Zkopírováno',
    another_bank: 'Jiná banka',
    download: 'Stáhnout',
    qrcode_notice:
      'Naskenujte QR kód pomocí mobilního telefonu a proveďte bankovní převod',
    qrcode_tooltip:
      'Naskenováním QR kódu nemusíte ručně kopírovat všechny údaje.',
    bank_separator: 'NEBO',
  },

  ocr_results: {
    html_title: 'Potvrďte své osobní údaje - kimbi.cz',
    title: 'Potvrďte své osobní údaje',
    info: 'Pokud zobrazené údaje nesouhlasí s Vaším dokladem, kontaktujte nás, prosím, na telefonním čísle <b>800 399 399</b>.',
    fullName: 'Jméno a příjmení',
    personal_id: 'Rodné číslo',
    dob: 'Datum narození',
    id_card: 'Číslo občanského průkazu',
    address: 'Trvalé bydliště',
  },

  waiting: {
    html_title: 'Zpracováváme Vaši žádost - kimbi.cz',
    title: 'Zpracováváme Vaši žádost',
    info: 'Buďte prosím trpěliví a nezavírejte tuto stránku, může to trvat až 1 minutu.',
  },

  pending: {
    html_title: 'Vaše žádost o půjčku byla přijata - kimbi.cz',
    title: 'Vaše žádost o půjčku byla přijata',
    description_1:
      'Vaše žádost bude vyhodnocena po ověření Vaší totožnosti a po ověření Vašeho bankovního účtu.',
    description_2:
      'V případě, že jste využili služeb Bankovní identity a ověření účtu online, již není potřeba dokládat občanský průkaz a zasílat ověřovací platbu ve výši 0,01 Kč.  V opačném případě, prosíme, postupujte podle kroků uvedených níže. ',
    to_finish: 'Pro dokončení žádosti, je potřeba:',
    accordion: {
      title_1: 'Nahrát kopii občanského průkazu.',
      uploaded_1: 'Kopie občanského průkazu byla úspěšně nahrána.',
      title_2: ' Provést ověřovací platbu 0,01 Kč.',
      content_2:
        'Zašlete platbu z Vašeho bankovního účtu, který je veden na Vaše jméno. Informace, na jaký bankovní účet a s jakým variabilním symbolem platbu zaslat, Vám byla zaslána emailem.',
      title_3: 'Nahrát potvrzení o příjmu.',
      uploaded_3: 'Potvrzení o příjmu bylo úspěšně nahráno.',
      confirm: 'Potvrdit',
    },
    info_card: {
      title: 'Nedaří se Vám nahrát potřebné dokumenty?',
      description: `Kopii občanského průkazu a potvrzení o příjmu za 3 měsíce můžete zasílat také emailem na ${EMAIL}`,
    },
    offer: {
      title: 'Podrobnosti Vaší žádosti',
      loan: 'Výše půjčky',
      due_date: 'Datum splatnosti minimální měsíční splátky',
    },
  },

  calculator: {
    edit: 'Upravit částku',
    mobile_amount_swiper_title: 'Výše půjčky (Kč)', // Remove when all references are removed
    mobile_term_swiper_title: 'Délka splatnosti (dnů)', // Remove when all references are removed
    amount_slider_title: 'Půjčka',
    term_slider_title: 'Výše půjčky', // Remove when all references are removed
    currency_amount: '{amount} Kč',
    amount_units: 'Kč',
    term_units: 'dnů',
    offer: {
      mtp: 'První minimální měsíční splátka',
      loan: 'Výše půjčky',
      due_date: 'Datum splatnosti minimální měsíční splátky',
      totalInterest: 'Úrok',
      interestRate: 'Zápůjční úroková sazba (ročně)',
      totalRepayableAmount: 'Celkem splatíte',
      futureExtensionFees: 'Následující minimální měsíční splátka:',
    },
    btn: 'Potvrdit částku',
  },

  identification_upload: {
    html_title: 'Ověření totožnosti - kimbi.cz',
    title: 'Ověření totožnosti',
    info: 'Připravte si, prosím Váš občanský průkaz. Fotografie dokladu pořídíte kliknutím na box občanský průkaz',
    additional_document_info:
      'Jako druhý doklad můžete použít řidičský průkaz, pas, nebo zbrojní průkaz',
    modal_info:
      'Před pořízením fotografie se ujistěte, že doklad je na neutrálně barevném pozadí a údaje jsou čitelné.',
  },

  proof_income: {
    html_title: 'Potvrzení o příjmu - kimbi.cz',
    title: 'Potvrzení o příjmu',
    information:
      'Prosíme o nahrání dokumentu pro ověření Vašeho příjmu. Akceptujeme výpis z bankovniho účtu, výplatní pásky nebo potvrzení o přijmu od zaměstnavatele. Dokumenty dokládající Váš přijem, nesmí být starší než 3 měsíce.',
    information_2:
      'Pro automatické zpracování je nutné nahrát bankovní výpisy ve formátu PDF. Dokumenty v jiných formátech nebo jiné typy dokladů budou zpracovány manuálně, což může prodloužit dobu vyhodnocení.',
    card_title: 'Nahrát dokument z Vašeho zařízení',
    link_name: 'Zaslat později emailem',
  },

  document_upload_later: {
    html_title: 'Potvrzení o příjmu - kimbi.cz',
    heading: 'Potvrzení o příjmu',
    main_doc_heading: 'Nahrát dokument z Vašeho zařízení',
    help_heading: 'Máte otázku? Máte dotaz?',
    send_later_text: `Pro úplné posouzení Vaší žádosti nám zašlete doklad, potvrzující Váš příjem. Akceptujeme výpis z bankovního účtu za poslední 3 měsíce, výplatní pásky za poslední 3 měsíce nebo potvrzení o příjmu od zaměstnavatele. Doklady nám zašlete emailem na <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_NO_SPACES}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info_holidays: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_NO_SPACES}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
  },

  rejected_offer: {
    html_title:
      'Je nám velmi líto. Ale Vaše žádost o půjčku byla zamítnuta na základě interního vyhodnocení - kimbi.cz',
    title: 'Je nám velmi líto',
    sub_title:
      'Ale Vaše žádost o půjčku byla zamítnuta na základě interního vyhodnocení.',
    button: 'Úvodní stránka',
    info_text:
      'Až se Vaše situace změní, budeme velmi rádi, pokud se na nás znovu obrátíte a budeme Vám moci vyhovět a půjčku poskytnout.',
  },

  help_info: {
    title: 'Nějaké otázky?',
    contact_details_holiday: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>. <div>Svátky / ${TIME_HOLIDAY_HOURS}</div>`,
    contact_details: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>. <div>Po.Pá / 8:00 — ${TIME_WORKING_END_HOURS}</div>`,
    text: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
  },

  document_upload: {
    id_title: 'Občanský průkaz',
    id_front_title: 'Občanský průkaz',
    id_front_subtitle: '(přední strana)',
    id_back_title: 'Občanský průkaz',
    id_back_subtitle: '(zadní strana)',
    selfie_title: 'Selfie',
    selfie_subtitle: '(autoportrét)',
    income_proof_title: 'Potvrzení o příjmu',
    other_document_title: 'Další dokument',
    other_document_subtitle: 'Volitelný dokument',
    upload_button: 'Nahrát dokument',
    upload_button_optional: 'Další dokument',
  },

  manual_upload_id: {
    html_title: 'Ověření totožnosti - kimbi.cz',
    title: 'Ověření totožnosti',
    info: 'Připravte si, prosím, Váš občanský průkaz. Fotografii nahrajte prostřednictvím Vašeho mobilního zařízení.',
    magic_link_title: 'Pořiďte fotografii pomocí mobilního telefonu',
    magic_link_info:
      'Po otevření odkazu, který Vám zašleme SMS zprávou, vyfoťte pomocí mobilního telefonu obě dvě strany Vašeho občanského průkazu.',
    send_sms: 'Odeslat SMS',
    magic_link_hint: `Může chvíli trvat, než Vám SMS dorazí. Pokud jste SMS neobdrželi, tak pro dokončení žádosti kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
    desktop_title: 'Nahrát dokument z Vašeho zařízení',
    second_doc_title: 'Druhý doklad',
    second_doc_title_card: 'Druhý doklad',
    second_doc_desc:
      'Jako druhý doklad totožnosti akceptujeme: Řidičský průkaz, pas nebo zbrojní průkaz.',
  },

  bank_id: {
    html_title: 'Ověřit se Bankovní Identitou - kimbi.cz',
    title: 'Ověřit se Bankovní Identitou',
    subtitle:
      'Šetřete čas a nechejte si pohodlně a bezpečně ověřit vaší identitu pomocí Bank iD. ',
    box_title:
      'Chcete-li používat BankID, musíte splňovat následující požadavky:',
    box_row_1: 'Bankovní účet vedený na Vaše jméno',
    box_row_2: 'Mít Bank iD u jedné z podporovaných bank v ČR',
    box_row_3: 'Platné telefonní číslo a e-mailovou adresu.',
    continue: 'Pokračovat s bankovní identitou',
    missing_id: 'Nemám bankovní identitu',
    mismatch_title: 'Chyba v údajích',
    mismatch_description:
      'Náš systém zjistil nesrovnalost mezi údaji, které jste zadali při první registraci a údaji, které jsme obdrželi od BankID. Může to být způsobeno překlepem nebo chybou v poskytnutých informacích, nebo technickým problémem s BankID.',
    mismatch_description2:
      'Prosím, zkuste to později nebo pokračujte v běžné registraci.',
    continue_with_standard_registration: 'Pokračovat v běžné registraci',
    try_again: 'Zkusit znovu',
    error_title: 'Omlouváme se, něco se pokazilo',
    error_description:
      'Nejsme schopni zpracovat údaje poskytnuté Vaší bankou. Prosím, pokračujte v žádosti vyplněním formuláře.',
  },

  bank_id_confirm: {
    html_title: 'Potvrďte Vaše osobní údaje - kimbi.cz',
    title: 'Potvrďte Vaše osobní údaje',
    info: 'Důkladně zkontrolujte zadané osobní údaje a ujistěte se, že v nich nejsou žádné chyby.',
    link_text: 'Ne, informace nejsou správné, chtěl bych zadat data ručně.',
    form: {
      full_name: 'Jméno a příjmení',
      full_age: 'Věk a datum narození',
      personal_Id: 'Rodné číslo',
      card_number: 'Číslo OP',
      address: 'Adresa',
      bank_list:
        'Ve Vašem bankovnictví jsme našli více účtů. Zvolte jeden účet, který chcete použít pro vyplaceni peněz:',
    },
    btn: 'Potvrdit',
  },

  bank_id_error: {
    title: 'Omlouváme se, něco se pokazilo',
    description:
      'Nejsme schopni zpracovat údaje poskytnuté Vaší bankou. Prosím, pokračujte v žádosti vyplněním formuláře.',
    default: {
      title: 'Omlouváme se, něco se pokazilo',
      description:
        'Nejsme schopni zpracovat údaje poskytnuté Vaší bankou. Prosím, pokračujte v žádosti vyplněním formuláře.',
      continue: 'Zkusit znovu',
    },
    foreigner: {
      title:
        'Je nám líto, z interních důvodů nemůžeme zpracovat Vaší žádost o půjčku.',
      description: 'Pokud se podmínky změní, budeme Vás kontaktovat.',
      continue: 'Zkusit znovu',
    },
  },

  bank_id_account_selection: {
    bank_details: 'Bankovní údaje',
    info_text_single_account:
      'Tento účet bude použit pro vyplacení půjčky. Zkontrolujte si, že je číslo účtu správně.',
    info_text_multiaccount:
      'Vybraný účet bude použit pro vyplacení půjčky. Zkontrolujte si, že je účet správný.',
    single_account_button: 'Ano, účet chci použít',
    info_text_multiaccount_button: 'Použít vybraný účet',
    reject_text: 'Ne, chci použít jiný účet',
    account_label: 'Osobní účet CZK',
  },

  psd2_banks: {
    html_title: 'Ověření bankovního účtu - kimbi.cz',
    title: {
      income: 'Ověření příjmu',
      income_and_bank_account: 'Ověření bankovního účtu',
    },
    bankid_subtitle: 'Vybraný účet bude použit pro ověření příjmů.',
    search: 'Zadejte jméno banky',
    card_title: {
      income: 'Vyberte účet, který použijeme pro ověření Vašich příjmů.',
      income_and_bank_account:
        'Vyberte účet, který použijeme pro zaslání ověřovací platby 0,01 Kč a ověření Vašich příjmů.',
    },
    card_subtitle:
      'Budete přesměrování na přihlašovací stránku Vaší banky, kde se přihlásíte stejným způsobem jako do Vašeho internetového bankovnictví.',
    show_all: 'Ostatní banky',
    manual: {
      btn: 'Moje banka není v seznamu',
      income:
        'Pokud Vaše banka není v seznamu, nahrajte nám doklady potvrzující Váš příjem',
      income_and_bank_account:
        'Pokud Vaše banka není v seznamu, zadejte platbu ručně přímo v internetovém bankovnictví.',
    },
    continue: 'Pokračovat',
    skip: {
      income: 'Přeskočit',
      income_and_bank_account: 'Přeskočit a zaslat platbu později',
    },
  },

  psd2_guide: {
    html_title: 'Ověření bankovního účtu – kimbi.cz',
    title: 'Návod pro přihlášení do internetového bankovnictví',
    continue: 'Pokračovat',
    back: 'Zpět na výběr banky',
    default: {
      step_1: 'Přihlaste se do zvolené banky.',
      step_2: 'Po přihlášení připravíme stažení výpisů.',
      step_3: 'Údaje jen potvrdíte a z účtu Vás následně bezpečně odhlásíme.',
      additional_1:
        'Nezapomeňte, že pro úspěšné provedení ověřovací platby musí být na účtu alespoň minimální zůstatek 0,01 Kč.',
    },
  },

  psd2_consents: {
    skip: 'Přeskočit a zaslat platbu později',
    page_title: 'Udělení souhlasu',
    html_title: 'Udělení souhlasu – kimbi.cz',
    description:
      'V následujícím kroku budete přesměrováni na přihlašovací stránku do internetového bankovnictví banky',
  },

  psd2_bank_account_select: {
    account_label: 'Osobní účet CZK',
    description:
      'Zvolte účet, který chcete použít pro odeslání ověřovací platby ve výši 0,01 Kč.',
    html_title: 'Ověření příjmu - kimbi.cz',
    info_text_multiaccount:
      'Vybraný účet bude použit pro vyplacení půjčky. Zkontrolujte si, že je účet správný.',
    info_text_single_account:
      'Tento účet bude použit pro vyplacení půjčky. Zkontrolujte si, že je číslo účtu správně.',
    page_title: 'Ověření příjmu',
  },

  psd2_receiving: {
    html_title: 'Ověření příjmu - kimbi.cz',
    page_title: 'Ověření příjmu',
    description:
      'Probíhá zpracování Vaší transakční historie. Prosíme o strpení, může to trvat několik minut ',
  },

  psd2_verified: {
    html_title: 'Ověření příjmu proběhlo v pořádku - kimbi.cz',
    page_title: 'Ověření příjmu proběhlo v pořádku.',
    item_1: 'Zpracování transakční historie proběhlo v pořádku.',
    item_2: 'Z účtu jsme Vás bezpečně odhlásili.',
    complete: 'Dokončit žádost',
  },

  psd2_error: {
    html_title: 'Omlouváme se, něco se pokazilo - kimbi.cz',
    page_title: 'Omlouváme se, něco se pokazilo.',
    info_text:
      'Omlouváme se, něco se pokazilo. Nejsme schopnit zpracovat údaje poskytnuté Vaší bankou. Prosím, pokračujte dále v žádosti.',
    continue_button: 'Pokračovat',
    title: 'Chyba při zpracování příjmu',
    description:
      'Vážený kliente, při zpracování Vašeho příjmu došlo k neočekávané chybě.',
    description_old_statement:
      'Nahraný bankovní výpis není za požadované období posledních 3. měsíců. Pro ověření příjmů akceptujeme výpis z bankovního účtu za poslední 3 měsíce, výplatní pásky za poslední 3 měsíce nebo potvrzení o příjmu od zaměstnavatele.',
    description_password_protected:
      'Nahrané přilohy se nepodařilo otevřít, je možné, že jsou zaheslovány. Přílohy můžete zkusit zaslat znovu nezaheslované nebo využít jinou z níže uvedených možností.',
    description_processing_error:
      'Vážený kliente, Při zpracování Vašeho příjmu došlo k neočekávané chybě.',
    description_unsupported_format:
      'Vámi poskytné dokumenty jsme nedokázali zpracovat.<br>V případě, že jste nahrali výplatní pásky, vyčkejte až Vás budeme kontaktovat nebo zvolte jiný způsob ověření příjmu.',
    description_name_mismatch:
      'Vámi dodané výpisy z účtu nejsou vedeny na Vaše jméno.',
    description_no_income:
      'Na Vámi dodaných výpisech z účtu jsme nenašli žádný příjem.',
    description_invalid_account_type: 'Vámi zvolený typ účtu není podporován.',
    description_account_name_mismatch:
      'Vámi zvolený bankovní účet není vedený na Vaše jméno.',
    description_account_no_income:
      'Na Vámi zvoleném bankovním účtu jsme nenašli žádný příjem.',
    select_option:
      'Prosím, vyberte jednu z následujících možností, jak chcete dále pokračovat:',
    select_option_description: `Pokud nevyberete žádnou z možností, nevadí. Budeme Vás sami kontaktovat v pracovní dny mezi 8:00 a ${TIME_WORKING_END_HOURS} hodinou.`,
    verify_online: 'Ověřit příjem online',
    verify_online_button: 'Ověřit online',
    verify_upload: 'Ověřit příjem nahráním příloh',
    verify_upload_button: 'Nahrát přílohy',
    send_email: 'Zaslat emailem',
    send_email_button: 'Zaslat email',
  },

  loading_screen: {
    title: 'Zpracováváme Vaší žádost',
    subtitle:
      'Buďte prosím trpěliví a nezavírejte tuto stránku, může to trvat až 1 minutu.',
  },

  psd2_result: {
    no_error: {
      title: 'Pokračujte v žádosti o půjčku',
      button: 'Pokračovat',
    },
    any_error: {
      title: 'Omlouváme se, něco se pokazilo',
      text: 'Pokračujte k ověření účtu.',
      button: 'Pokračovat',
    },
    special_error: {
      title: 'Omlouváme se, něco se pokazilo',
      text: 'Zkuste to prosím znovu za chvíli.',
      button: 'Zkusit znovu',
    },
    offline_any: {
      title: 'Omlouváme se, něco se pokazilo',
      text: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
    },
    offline_case_finished: {
      title: 'Děkujeme, Vaše žádost se zpracovává',
      text: 'o jejím výsledku Vás budeme neprodleně informovat',
    },
    offline_finished_without_payment: {
      title: 'Omlouváme se, provedení ověřovací platby se nezdařilo',
      text: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
    },
    offline_finished_no_transaction_history: {
      title: 'Omlouváme se, ověření Vaší úvěruschopnosti se nezdařilo',
      text: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
    },
    offline_finished_without_payment_transaction_history: {
      title:
        'Omlouváme se, provedení ověřovací platby a ověření Vaší úvěryschopnosti se nezdařilo',
      text: `Pro dokončení žádosti prosím kontaktujte Zákaznickou linku ${PHONE}.`,
    },
    html_title: 'Výsledek identifikace offline - kimbi.cz',
  },
  manual_review: {
    html_title: 'Zpracování žádosti - kimbi.cz',
    html_title_resolved: 'Žádost zpracována - kimbi.cz',
    heading: 'Vyčkejte prosím, Vaše žádost se zpracovává',
    description:
      'Vaši žádost o půjčku jsme přijali. Nyní ji vyhodnocujeme. O výsledku Vaší žádosti Vás budeme kontaktovat prostřednictvím e-mailu a SMS.',
    heading_resolved: 'Vaše žádost byla zpracována',
    navigate: `Vyřízení žádosti`,
  },

  approved: {
    html_title: 'Gratulujeme! Vaše žádost byla dokončena - kimbi.cz',
    title: 'Gratulujeme! Vaše žádost byla schválena a peníze odeslány.',
    description:
      'Peníze odesíláme ihned. Připsání na Váš účet závisí na Vaši bance. Ve většině pořípadů máte peníze k dispozici okamžitě, nejpozději nejbližší pracovní den. Smlouvu naleznete v sekci Můj přehled.',
    in_case: 'V případě, že:',
    accordion: {
      title_1: 'Jste v žádosti nedodal/a kopii Vaše občanského průkazu',
      content_1: `Zašlete nám ofocenou kopii Vašeho občanského průkazu z obou stran na náš email: ${EMAIL}`,
      title_2: 'Jste neprovedl/a ověřovací platbu během vyplňování žádosti',
      content_2:
        'Zašlete platbu z Vašeho bankovního účtu, který je veden na Vaše jméno. Informace, na jaký bankovní účet a s jakým variabilním symbolem platbu zaslat, Vám byla zaslána emailem.',
    },
    go_to_account: 'Přejít na zákaznický účet',
    congratulation: {
      title: 'Děkujeme, že jste si nás vybrali!',
      text: 'Vždy se snažíme o to, abyste byli maximálně spokojeni. Věnujte prosím 3 minuty svého času následujícímu dotazníku a podělte se s námi o Váš názor.',
      btn: 'SPUSTIT DOTAZNÍK',
    },
  },

  not_finished_application: {
    page_title: 'Dokončení žádosti - kimbi.cz',
    title: 'Dokončení žádosti o půjčku',
    info_title:
      'Pro dokončení žádosti o půjčku od Vás ještě budeme potřebovat provést několik kroků:',
    step_1: 'Nahrát fotografii občanského průkazu.',
    step_2: 'Zaslat identifikační platbu.',
    step_3:
      'V případě potřeby si od Vás vyžádáme ještě potvrzení o příjmu nebo výpis z bankovního účtu.',
    link: 'Zrušit rozpracovanou žádost a začít znovu',
  },
  finance: {
    html_title: 'Prosím zkontrolujte si níže uvedené informace - zaplo.cz',
    heading_modal: 'Finance, vzdělání a domácnost',
    profession: 'Jaké máte povolání?',
    profession_placeholder: 'Vyberte ze seznamu',
    heading: 'Prosím zkontrolujte si níže\nuvedené informace',
    heading_mobile: 'Prosím zkontrolujte',
    monthly_income_placeholder: 'Čistý měsíční příjem žadatele',
    monthly_income_desc:
      'Uveďte výši Vašeho čístého měsíčního příjmu. Čistý měšíční příjem (po zdanění)',
    monthly_expenses: 'Měsíční výdaje žadatele',
    monthly_expenses_desc:
      'Doplňte aktuální celkovou výši nezbytných pravidelných měsíčních výdajů, zejména výdaje na bydlení (nájemné, platby za služby), dopravu, domácnost, nezaopatřené děti, výše pravidelných měsíčních splátek a dalších nezbytných výdajů.',
    household_members: 'Celkový počet členů Vaší domácnosti',
    employed_household_members:
      'Celkový počet členů Vaší domácnosti s pravidelným příjmem',

    housing_type: 'Druh bydlení',
    btn: 'Pokračovat',
    consent_heading:
      'Pro možnost čerpání našich služeb v plném rozsahu Vás žádáme i o udělení tohoto souhlasu:',
    ownership_types: {
      rent: 'Podnájem / nájem',
      mortgage: 'Hypotéka',
      owned: 'Ve vlastnictví',
      with_relatives: 'S příbuznými',
      collective: 'Družstevní byt',
      employer: 'Firemní byt',
      dormitory_or_hotel: 'Kolej / ubytovna / hotel',
    },
    education_type: 'Vzdělání',
    income_source_type: 'Zdroj příjmů žadatele',
    income_source_type_desc:
      'Zvolte zdroj Vašich příjmů výběrem jedné z možností.',
    employer: 'Název firmy / IČO zaměstnavatele',
    employer_osvc: 'Zadejte název Vaší živnosti nebo Vaše IČO',
    update: {
      before_link: 'Pokud některý z uvedených údajů není aktuální,',
      link: 'klikněte sem',
      after_link: 'pro jejich úpravu.',
    },
    field_update: 'Prosím, aktualizujte tyto informace.',
    update_submit_btn: 'Aktualizovat moje údaje',
    modal: {
      title: 'Dodatečné informace o Vás',
      desc: 'Abychom mohli Vaši žádost o pujčku co nejlépe posoudit, prosíme, vyplňte název Vašeho zaměstnavatele nebo IČO. Tato informace pomůže při zpracování žádosti. Vašeho zaměstnavatele kontaktovat nebudeme.<br />V případě, že nemůžete nalézt Vašeho zaměstnavatele na seznamu, klikněte níže na "Můj zaměstnavatel není na seznamu" a údaj vyplňte ručně.',
      desc_osvc:
        'Abychom mohli Vaší žádost o půjčku co nejlépe posoudit, prosíme, vyplňte název Vaši živnosti nebo Vaše IČO. Tato informace pomůže při zpracování žádosti.<br /><br />V případě, že nemůžete nalézt Vaši živnost nebo Vaše IČO na seznamu, stiskněte tlačítko “Moje živnost není na seznamu“ a údaj vyplňte ručně.',
    },
  },
  education_employment: {
    identification_number: 'IČO: ',
    search: 'Vyhledávání',
    not_found_text: 'Můj zaměstnavatel není na seznamu.',
    not_found_text_selfemployed: 'Moje živnost není na seznamu',
    search_for_employer: 'Chci vyhledat zaměstnavatele znovu',
    search_for_employer_selfemployed: 'Znovu vyhledat živnost',
    manual_input_placeholder: 'Zadejte IČO nebo název firmy (subjektu)',
    manual_input_placeholder_selfemployed: 'Vyplňte ručně',
    education: {
      elementary: 'Základní',
      secondary: 'Střední',
      diploma: 'Střední s maturitou',
      bachelor: 'Vyšší odborné a bakalářské',
      university: 'Vysokoškolské',
    },
    income_sources: {
      employee: 'Zaměstnanec',
      self_employed: 'OSVČ',
      entrepreneur: 'Podnikatel (s.r.o.)',
      maternity_leave: 'Mateřská dovolená',
      in_household: 'V domácnosti',
      student: 'Student',
      unemployed: 'Nezaměstnaný',
      retiree: 'Důchodce',
      other: 'Ostatní',
    },
  },
  offerTable: {
    loan: 'Výše půjčky',
    title_1: 'Při splacení do 30 dnů',
    totalRepayableAmount: 'Celková splatná částka:',
    interestRate: 'Výše úrokové sazby:',
    firstPaymentDate: 'Datum splatnosti:',
    title_2: 'Při splacení v podobě minimální měsíční splátky',
    extensionFees: 'První minimální mesíční splátka:',
    futureExtensionFees: 'Následující minimální měsíční splátka:',
    assignedInterest: 'Výše úrokové sazby po uplynutí prvních 30 dnů:',
    paymentDate: 'Datum splatnosti první minimální měsíční splátky:',
    confirm: 'Potvrdit',
  },
  phoneCode: {
    title: 'Podepsání smlouvy',
    desc: 'Pro podepsání této smlouvy o úvěru zadejte kód, který Vám byl zaslán na Vaši emailovou adresu <strong>{email}</strong> a telefonní číslo <strong>{phone}</strong>',
    otpLabel: 'Potvrzovací kód',
    resendText: 'Kód nedorazil?',
    resendBtn: 'Znovu zaslat kód',
    submitBtn: 'Podepsat a potvrdit',
    footerText: `Může chvíli trvat, než Vám SMS dorazí. Pokud jste neobdrželi SMS s kódem, zkontrolujte si složku spam, nebo si nechte kód zaslat znovu.
                 V případě opakovaného problému kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_NO_SPACES}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
    cancelText: 'Rozmysleli jste si to nebo narazili na technický problém?',
    cancelBtn: 'Zrušit žádost',
  },
};

export default cz;
